import { useQuery } from "@tanstack/react-query";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import api from "@/common/utils/api";

import { featureQueryKeys } from "./featureQueryKeys";

export function useFeatureConfigData(featureId?: string) {
  const { app } = useEnvironment();

  return useQuery({
    queryKey: featureQueryKeys.config(app.id, featureId),
    queryFn: () =>
      api
        .get<"/apps/:appId/features/:featureId/config">(
          `/apps/${app.id}/features/${featureId}/config`,
        )
        .then((res) => res.data),
    enabled: !!app && !!featureId,
  });
}
